import {
  ExecutionPatchIncrementalResult,
  ExecutionPatchInitialResult,
  SingleExecutionResult,
} from '@apollo/client';
import { formatInTimeZone } from 'date-fns-tz';

import { GetArticleIdQuery, GetAssemblyCollectionPageIdQuery } from '../graphql/__generated/sdk';

const REGEX_CONTENTFUL_ASSETS = /(images|videos|downloads|assets)\.ctfassets\.net/g;

export const SCROLL_STOP = 'scroll-stop';

export function isMobileView(): boolean {
  const element = document.querySelectorAll('[data-mobile-detector]')[0];
  return !!(element && getComputedStyle(element).display !== 'none');
}

export default function replaceContentfulAssetsHost(
  response: SingleExecutionResult | ExecutionPatchInitialResult | ExecutionPatchIncrementalResult
) {
  return JSON.parse(
    JSON.stringify(response).replaceAll(REGEX_CONTENTFUL_ASSETS, `${process.env.REACT_APP_HOST}/$1`)
  );
}

export function disableScroll() {
  document.body.classList.add(SCROLL_STOP);
}

export function enableScroll() {
  document.body.classList.remove(SCROLL_STOP);
}

export function generateArrayWithUniqueEntries<T>(list: T[]): T[] {
  return Array.from(new Set(list));
}

export function formatDateToUTC(date: string, dateFormat?: string): string {
  return formatInTimeZone(new Date(date), 'UTC', dateFormat || 'yyyy-MM-dd');
}

export function getSlugFromLocationPath(pathname: string): string | undefined {
  return pathname.split('/').pop();
}

export function getEntryId(data: GetArticleIdQuery | GetAssemblyCollectionPageIdQuery | undefined) {
  if (data?.svData?.items.length) {
    return data?.svData?.items[0].sys.id;
  }

  if (data?.enData?.items.length) {
    return data?.enData?.items[0].sys.id;
  }
}

export function createMultipleSizeImages(image: {
  url: string;
  altText: string;
  focusArea: string;
}) {
  const RESIZE_STRATEGY = 'fill';

  const SMALL_WIDTH = 900;
  const SMALL_HEIGHT = 500;

  // Width and height of 16:9 aspect ratio
  const LARGE_WIDTH = 2000;
  const LARGE_HEIGHT = 1125;

  const focusArea = image.focusArea ? image.focusArea : 'center';

  return {
    default: image.url,
    small: `${image.url}&f=${focusArea}&fit=${RESIZE_STRATEGY}&w=${SMALL_WIDTH}&h=${SMALL_HEIGHT}`,
    large: `${image.url}&f=${focusArea}&fit=${RESIZE_STRATEGY}&w=${LARGE_WIDTH}&h=${LARGE_HEIGHT}`,
    altText: image.altText,
  };
}

export function parseNumericString(val: any) {
  return !isNaN(val) ? parseInt(val) : val;
}

export function capitalizeText(val: string) {
  return val.charAt(0).toUpperCase() + val.slice(1).toLowerCase();
}
